<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import ItemsApi from "@/services/items-api";
import OrdersApi from "@/services/orders-api";
import OrderModal from "@/components/orderModal"
import OrderSummary from "@/components/OrderSummary"
import { debounce } from "lodash";
import QuickOrderItemSelect from "@/components/QuickOrderItemSelect";

export default {
  page: {
    title: "commande rapide",
    meta: [{ name: "description", content: appConfig.description }]
  },


  components: { OrderModal, OrderSummary, QuickOrderItemSelect },

  props:{
    order: {
      type: Object,
      default: () => {}
    },
    csvImportErrorsValue: {
      type: Array,
      default: () => []
    },
    dbAgencyId: {
      default: null
    },
  },

  data() {
    return {
      orderData: this.order ? { ...this.order } : {},
      isDesktop: window.innerWidth >= 800 ,
      orderline:  { ref: '', title: '', quantity: null, price: 0, lineTotalAmount: 0 },

      isOrderPending: false,

      itemsList:[],
      autoCompleteItemsList: [],
      pagemodel: {currentPage : 1, perPage : 15, totalRows: 0},

      selectedItems: [],
      isTableLoading:false,
      isCsvImporting: false,
      // entry mode of the lines fixed in "Lignes erronées": the kind of file they were imported from
      csvImportEntryMode: 'IMPORT_CSV',
      // local copy so reads right after an assignment see the new list; mirrored to the parent (.sync)
      csvImportErrors: this.csvImportErrorsValue,
      csvAutoCompleteItemsList: [],
      showItemModal: false, 
      isCheckingOrder:false,
      orderErrors:null,
      selectedDeliveryAddress: null,
      showOrdersDetailsModal:false,
      showImageModal:false,
      selectedItem:null,

      searchText:null,
      autoCompleteSelectedItem: null,

      itemsListFields: [
        { key: "ref", thClass: "text-left", tdClass: "text-left font-weight-bold align-middle" },
        { key: "title", thClass: "text-left ", tdClass: "text-left align-middle font-weight-bold no-wrap", thStyle: "min-width:310px;" },
        { key: "image", label: "", thClass: "text-left", tdClass: "text-left align-middle font-weight-bold no-wrap", thStyle: "width:5px;" },
        { key: "stockStatus", thClass: "text-center", tdClass: "text-center align-middle", thStyle: "min-width:90px;" },
        { key: "packageCount", label: "Unités par carton", thClass: "text-right", tdClass: "text-right align-middle", thStyle: "width:150px;" },
        { key: "gratuity", label: "Promo", thClass: "text-right", tdClass: "text-right align-middle" },
        { key: "pricePublic", label: "Prix Public", thClass: "text-right", tdClass: "text-right align-middle no-wrap", thStyle: "width:100px;" },
        { key: "discountedPrice", thClass: "text-right", tdClass: "text-right align-middle no-wrap", thStyle: "width:100px;" },
        { key: "priceTaxIncl", label: "Prix TTC", thClass: "text-right", tdClass: "text-right font-weight-bold align-middle no-wrap", thStyle: "width:100px;" }
      ],

      quickOrderFields: [
            { key:"ref", sortable: false, thStyle:"width:150px;"},
            { key:"title", sortable: false, thStyle:"width:480px"},
            { key:"quantity", sortable: false, tdClass:"text-right", thClass:"text-right", thStyle:"width:90px"},
            { key:"price", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:120px"},
            { key:"lineTotalAmount", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
          ],
      csvErrorFields: [
        { key: "lineNumber", label: "Ligne", thStyle: "width:80px;" },
        { key: "barcode", label: "Code à barre", thClass: "csv-error-barcode-column", tdClass: "csv-error-barcode-column align-middle", thStyle: "min-width:260px;width:38%;" },
        { key: "pctCode", label: "Code PCT" },
        { key: "quantity", label: "Quantité", tdClass: "text-right", thClass: "text-right" },
        { key: "error", label: "Erreur", tdClass: "text-danger font-weight-bold" },
        { key: "actions", label: "", thStyle: "width:110px;" }
      ],
      
    };
  },  
  
    mounted() {
      // the order page shows the import button and its spinner
      this.$emit('csv-importing', this.isCsvImporting);

      if (this.role == 0 ) {
        this.autoFocusInput("orderLineTitle")
      }

      this.searchAutoCompleteItem("")
    },

      created() {
        this.debouncedSearch = debounce(this._searchItems, 300);
      },

    computed:{
      draftOrderId() {
        return this.$cookies.isKey('drafto') ? this.$cookies.get('drafto') : null;
      },

      orderlineForBTable() {
        return [this.orderline];
      },

      role() {
        return this.$cookies.get('userr');
      },

      // same switch as the import box on the order page
      isCsvImportEnabled() {
        return process.env.VUE_APP_FEATURE_QUICK_ORDER_CSV_IMPORT === 'true';
      },

    },

    watch: {
      searchText(newVal) {
        this.showAndHideDropDown(newVal)
      },
      isCsvImporting(value) {
        this.$emit('csv-importing', value);
      },
      csvImportErrors(value) {
        this.$emit('update:csvImportErrorsValue', value);
      },
      csvImportErrorsValue(value) {
        if (value !== this.csvImportErrors) {
          this.csvImportErrors = value;
        }
      }
    },


    methods: {

    isPanacheSelectionItemsError(item) {
      return item && item.errorKey === 'panache.selection.items'
    },

    refreshErrorLines(orderedLineBarcodes) {
        if (!Array.isArray(orderedLineBarcodes) || !orderedLineBarcodes.length) {
            return
        }

        const normalizedRefs = new Set(
            orderedLineBarcodes
                .map(ref => String(ref || "").trim())
                .filter(Boolean)
        )

        this.csvImportErrors = this.csvImportErrors.filter(line =>
            line.errorKey !== "panache.selection.items" ||
            (!normalizedRefs.has(String(line.pctCode || "").trim()) &&
             !normalizedRefs.has(String(line.selectedItem && line.selectedItem.ref || "").trim()))
        )
    },

    selectCsvFile() {
      this.$refs.quickOrderCsvInput.click()
    },

    // order file templates with placeholder data, served from public/modeles:
    // TXT = Code à barre;Code PCT;Désignation;Quantité, Excel = the pharmacy order document (lines from row 10, 2 closing rows)
    downloadImportTemplate(format) {
      const fileName = format === "xls" ? "modele-commande.xls" : "modele-commande.txt"
      const link = document.createElement("a")
      link.href = (process.env.BASE_URL || "/") + "modeles/" + fileName
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    importCsv(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return

      const startImport = () => this.executeCsvImport(file, event)
      if (this.orderData && this.orderData.id) {
        Swal.fire({
          title: "Une nouvelle commande va être créée",
          html: "Les lignes du fichier CSV vont être importées dans une nouvelle commande. Le brouillon actuel sera conservé. Voulez-vous continuer ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Oui, importer",
          cancelButtonText: "Annuler"
        }).then(result => {
          if (result.value) {
            startImport()
          } else {
            event.target.value = ""
          }
        })
        return
      }

      startImport()
    },

    executeCsvImport(file, event) {
      this.csvImportEntryMode = /\.xlsx?$/i.test((file && file.name) || '') ? 'IMPORT_XLS' : 'IMPORT_CSV'
      this.isCsvImporting = true
      OrdersApi.importQuickOrderCsv(null, file, this.dbAgencyId)
        .then(result => {
          if (!result) {
            return
          } 

          this.csvImportErrors = (result.errors || []).map(error => ({
            ...error,
            selectedItem: error.selectedItem || null,
            error: this.formatCsvError(error.error),
            isRetrying: false,
            isResolvingItem: false,
            errorKey: error.error,
          }))

          this.preselectCsvErrorItems()

          if (result.order){
            this.orderData = result.order
          }
          const importedLineCount = result.importedLineCount || 0
          const importMessage = importedLineCount + " ligne(s) importée(s), " + this.csvImportErrors.length + " ligne(s) erronée(s)"
          if (importedLineCount > 0) {
            this.$snotify.success(importMessage)
          } else {
            this.$snotify.warning(importMessage)
          }

          if (this.orderData && this.orderData.id) {
            this.$emit('refresh', this.orderData.id)
          }
        })
        .catch(error => this.$snotify.error(this.getCsvImportErrorMessage(error)))
        .finally(() => {
          this.isCsvImporting = false
          event.target.value = ""
        })
    },

    getCsvImportErrorMessage(error) {
      if (!error) return "L'import CSV a échoué"
      if (typeof error === "string") return error
      return error.message || error.data || error.statusText || "L'import CSV a échoué"
    },
    formatCsvError(error) {
      if (!error) return "Erreur inconnue"
      const separatorIndex = error.indexOf(" (")
      const key = separatorIndex >= 0 ? error.substring(0, separatorIndex) : error
      const details = separatorIndex >= 0 ? error.substring(separatorIndex) : ""
      const translationKey = "quickOrder.csvErrors." + key
      const message = this.$te(translationKey) ? this.$t(translationKey) : key
      return message + details
    },

    preselectCsvErrorItems() {
      this.csvImportErrors.forEach(errorLine => {

        if (errorLine.selectedItem) {
          return
        } 

        this.$set(errorLine, "isResolvingItem", true)
        this.resolveCsvErrorItem(errorLine).then(selectedItem => {
        
          if (!selectedItem) {
            return
          }
            
          this.$set(errorLine, "selectedItem", selectedItem)

          errorLine.barcode = selectedItem.barcode || errorLine.barcode
          errorLine.pctCode = selectedItem.ref || errorLine.pctCode

        }).finally(() => {
          this.$set(errorLine, "isResolvingItem", false)
        })
      })
    },

    resolveCsvErrorItem(errorLine) {
      const barcode = (errorLine.barcode || "").trim()
      const pctCode = (errorLine.pctCode || "").trim()

      const findExactBarcode = items => items.find(item =>
        item.barcode && String(item.barcode).trim() === barcode
      )
      
      const findExactPctCode = items => items.find(item =>
        item.ref && String(item.ref).trim() === pctCode
      )

      const findByPctCode = () => {
        if (!pctCode) return Promise.resolve(null)
        return this.findCsvItems(pctCode).then(items => findExactPctCode(items) || null)
      }

      if (!barcode) return findByPctCode()
      return this.findCsvItems(barcode).then(items => {
        const barcodeItem = findExactBarcode(items)
        return barcodeItem || findByPctCode()
      })
    },

    findCsvItems(search) {
      return ItemsApi.findItems(1, 10, [], search,
        null, null, false, null, null, null, null, null, null,
        null, false, false, false, false, false, false, false,
        new Date().getTime()
      ).then(itemsList => itemsList.list || [])
    },

    searchCsvErrorItem(search, errorLine) {
      const enteredSearch = search ? search.trim() : ""
      const barcode = enteredSearch || (errorLine.barcode || "").trim()
      const pctCode = (errorLine.pctCode || "").trim()

      if (enteredSearch) errorLine.barcode = enteredSearch
      if (!barcode && !pctCode) {
        this.csvAutoCompleteItemsList = []
        return
      }

      const firstSearch = barcode || pctCode
      this.findCsvItems(firstSearch).then(items => {
        if (items.length || !pctCode || pctCode === firstSearch) {
          this.csvAutoCompleteItemsList = items
          return
        }
        this.findCsvItems(pctCode).then(pctItems => {
          this.csvAutoCompleteItemsList = pctItems
        })
      })
    },

    selectCsvErrorItem(errorLine) {
      const selectedItem = errorLine.selectedItem
      if (!selectedItem) return
      errorLine.barcode = selectedItem.barcode
      errorLine.pctCode = selectedItem.ref
      errorLine.error = ""
    },

    getCsvItemLabel(item) {
      if (!item) {
        return ""
      }

      if (item.isCsvDefault) {
        return item.barcode || item.ref || ""
      }
        
      return (item.barcode ? item.barcode + " - " : "") + item.title
    },

    addLineToOrder(errorLine) {
      if (!errorLine.selectedItem || !errorLine.selectedItem.id) {
        this.$set(errorLine, "isResolvingItem", true)
        this.resolveCsvErrorItem(errorLine).then(selectedItem => {
          if (!selectedItem) {
            errorLine.error = "Veuillez sélectionner un article"
            return
          }
          this.$set(errorLine, "selectedItem", selectedItem)
          this.addLineToOrder(errorLine)
        }).finally(() => {
          this.$set(errorLine, "isResolvingItem", false)
        })
        return
      }
      const quantity = Number(errorLine.quantity)

      if (!Number.isInteger(quantity) || quantity <= 0) {
        errorLine.error = "Quantité invalide"
        return
      }

      this.$set(errorLine, "isRetrying", true)

      OrdersApi.addLineToOrder( this.orderData ? this.orderData.id : null, errorLine.selectedItem.id, quantity, null,false, this.csvImportEntryMode, this.dbAgencyId)
        .then(orderData => {
          if (!orderData) return
          this.orderData = orderData
          this.csvImportErrors = this.csvImportErrors.filter(line => line !== errorLine)
          this.$snotify.success("Ligne ajoutée à la commande")
          this.$emit("refresh", this.orderData.id)
        }).catch(error => {
            const status = error?.response?.status || error?.status
            const message = error?.response?.data?.message || error?.message
            
            if (status === 428) {
                this.$emit('handlePanacheItemsError', error)
                errorLine.error = this.formatCsvError('panache.selection.items')
                return
            }

            errorLine.error = this.formatCsvError(
                message || "Impossible d'ajouter la ligne"
            )
        }).finally(() => {
          this.$set(errorLine, "isRetrying", false)
        })
    },

    removeCsvErrorLine(errorLine) {
      this.csvImportErrors = this.csvImportErrors.filter(line => line !== errorLine)
    },
      
    openImageModal(item){
      if(item && item.image){
        this.selectedItem = item
        this.showImageModal = true
      }
    },

      dropdownShouldOpen() {
          this.$nextTick(() => {
            if (!this.searchText || this.searchText.trim() === '') {
              this.$refs.orderLineTitle.setOpen(false);
            }
          }); 
      },

      showAndHideDropDown(searchText){
          if (!searchText || searchText.trim() == "" ) {
            this.$refs.orderLineTitle.setOpen(false);
          }else{
            this.$refs.orderLineTitle.setOpen(true);
          }
      },

      openVSelect() {
        const select = this.$refs.orderLineTitle;
        select.setOpen(false);
        setTimeout(() => {
          select.setOpen(true);
        }, 300);
      },

      checkOrder(){

        this.orderErrors = null;

        this.isCheckingOrder=true
        OrdersApi.checkOrder(this.orderData.id, this.orderMessage, 
        this.selectedPriority==null ? null : this.selectedPriority.value, 
        this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.id,
        false,this.desiredDeliveryDate,this.promotionCode).then(
          (result)=>{
            if(result){
              this.showOrdersDetailsModal =true
            }
          }
        ).finally(
          ()=>{
            this.isCheckingOrder=false
          }
        )

        .catch(error => {  this.orderErrors = error; })

        },

      addToOrder() {
        if (this.orderline && this.orderline.quantity == null || this.orderline.quantity ==0 ){
          this.orderline.quantity = 1
        }
      this.isTableLoading=true
      OrdersApi.addLineToOrder(this.order.id ?  this.order.id : null, this.orderline.id, this.orderline.quantity,null,false,'QUICK_ORDER', this.dbAgencyId) 
      .then(orderData => {
          if(orderData) {
            this.orderData = orderData; 

            this.reference = null;

          }
        })
        .then(()=>{
          this.isTableLoading=false
        }).catch((error)=>{
          this.$emit('handlePanacheItemsError' , error)
          this.orderline=  { ref: '', title: '', quantity: null, price: 0, lineTotalAmount: 0 }
          this.autoCompleteSelectedItem = null
           this.searchText = ''
        })
        .finally(()=>{
          this.isTableLoading=false
          this.orderline = {title: "", quantity: null }
          this.autoFocusInput("orderLineTitle")
          this.orderline=  { ref: '', title: '', quantity: null, price: 0, lineTotalAmount: 0 }
          this.autoCompleteSelectedItem = null
          this.searchText = ''
          this.$emit('refresh' , this.orderData.id)
        })
      },

      selectItem(items){
        const item = items[0]
        if(!item){
          return
        }

        if(item && item.stockStatus && (item.stockStatus == 2 || item.stockStatus == 3)){
          return
        }
          this.orderline = item
          this.orderline.quantity = null;
          this.showItemModal=false
          this.autoCompleteSelectedItem=items
      },

      autoFocusQuantityInput() {
        if (this.orderline && this.orderline.id) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.autoFocusInput("quantityInputField");
            }, 300);
          });
        }
      },

           
      autoFocusInput(refName) {
        this.$nextTick(() => {
          const component = this.$refs[refName];
          if (component && typeof component.focus === 'function') {
            component.focus();
          } else if (component && component.$el) {
            const input = component.$el.querySelector('input');
            if (input) input.focus();
              this.openVSelect()
          }
        });
      },

      onAutoCompleteInputEvent() {
        this.orderline.id = this.autoCompleteSelectedItem.id;
        this.orderline.title = this.autoCompleteSelectedItem.title;
        this.orderline.quantity = null;
        this.autoFocusQuantityInput();
      },
            

      selectFirstItem() {
        if (this.itemsList.length > 0) {
          this.$nextTick(() => {
            const firstRow = this.$refs.table.getTbodyTrs()[0];
            if (firstRow) {
              firstRow.focus();
            }
          });
        }
      },

      searchAutoCompleteItem(search) {
        if(search){
          this.orderline.title = search
        }
        this.searchText = search;
        this.debouncedSearch();
      },


      _searchItems() {  
          ItemsApi.findItems(1, 20, [], this.searchText, 
                      null, null, false, null, null,null,null, null, null,
                      null, false,false,false,false,false,false,false,
                      this.itemsListTimestamp
                      ).then(itemsList => {
                        this.autoCompleteItemsList=itemsList.list ;
                      })
      },

      findItems() {

        this.orderline.title = this.orderline && this.orderline.title ? this.orderline.title : this.searchText

        this.isItemsTableBusy = true;
        this.itemsListTimestamp = new Date().getTime();
        ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage, [], this.orderline.title , 
                            null, null, false, null, null,null,null, null, null,
                            null, false,false,false,false,false,false,false,
                            this.itemsListTimestamp
                            ).then(itemsList => {
                              this.itemsList=itemsList.list ;
                              this.pagemodel.totalRows = itemsList.total;
                              this.pagemodel.currentPage = itemsList.page;
                              this.pagemodel.perPage = itemsList.pageSize;
                              this.pagemodel.pageSize = itemsList.pageSize;
                                this.showItemModal = true;
                                this.selectFirstItem()
                            }).finally(() => {
                              this.isItemsTableBusy = false;
                              this.endOfFindItems = true;
                            });
      },

      getRemainingQuantityInControlledSaled(maxPerDay, alreadyOrderedPerDay) {
      const remainingQuantity = maxPerDay - alreadyOrderedPerDay;
      return remainingQuantity < 0 ? 0 : remainingQuantity;
    },

    closeOrderModal(){
        this.showOrdersDetailsModal=false
        this.clearAll();
    },

    clearAll(){
      this.clearOrder()
        if (this.role != 0) {

          this.selectedCustomer = null;

          this.selectedBrand = null;
          this.selectedGroup = null;
          this.selectedSubGroup = null;

          this.reference = null;
        }
    },

    getAutoCompleteOptionLabel(option) {
      return option ? option.title : '';
    },

  }

}

</script>



<template>
<div>
    <div class="row">
      
      <div class="col-12 ">

        <OrderSummary :order="orderData" class="mt-4 mb-3" />
        <!-- the "Importer une commande" box is shown by the order page (under the revenue status); the file input and the import stay here -->
        <input
          v-if="isCsvImportEnabled"
          ref="quickOrderCsvInput"
          type="file"
          accept=".txt,.xls,.xlsx,.csv"
          class="d-none"
          @change="importCsv"
        >
        
        <div class="table-responsive p-0 m-0 qo-grid-wrap">

          <b-table class="p-0 m-0 qo-grid" :striped="false" :small="false" :hover="false" :items="orderlineForBTable" :fields="quickOrderFields" responsive >
            <template v-slot:head(ref)>
              {{ $t("orderTabs.newOrderTab.orderFields.ref") }} 
            </template>
            <template v-slot:head(title)> 
              {{ $t("orderTabs.newOrderTab.orderFields.itemTitle") }}
            </template>
            <template v-slot:head(quantity)>
              {{ $t("orderTabs.newOrderTab.orderFields.quantity") }} 
            </template>
            <template v-slot:head(price)>
              {{ $t("orderTabs.newOrderTab.orderFields.price") }} 
            </template>
            <template v-slot:head(lineTotalAmount)>
              {{ $t("orderTabs.newOrderTab.orderFields.total") }} 
            </template>

            <template v-slot:cell(ref)="{item}">
              &nbsp;
            </template>


            <template v-slot:cell(title)>
              <div class="d-flex align-items-center  div-auto-complete qo-grid__search">
                <QuickOrderItemSelect
                  ref="orderLineTitle"
                  v-model="autoCompleteSelectedItem"
                  :options="autoCompleteItemsList"
                  :dropdown-should-open="dropdownShouldOpen"
                  :get-option-label="getAutoCompleteOptionLabel"
                  class="flex-grow-1 qo-grid__select"
                  @search="searchAutoCompleteItem"
                  @open="dropdownShouldOpen"
                  @input="onAutoCompleteInputEvent()"
                />

                <b-button variant="light" class="qo-grid__catalog-btn" @click="findItems()" >
                  <i class="fas fa-bars font-size-12 align-middle"/>
                </b-button>
              </div>
            </template>


            <template v-slot:cell(price)="{item}">
                &nbsp;
            </template>

            <template v-slot:cell(quantity)="{value, item}">
              <b-form-input ref="quantityInputField" placeholder="Qté" class="text-right qo-grid__qty"  v-model="orderline.quantity" @keyup.native.enter="addToOrder"  ></b-form-input>                          
            </template>
          </b-table>
        </div> 

        <div v-if="csvImportErrors.length" class="mt-4">
          <h5 class="text-danger font-weight-bold">Lignes erronées</h5>
          <b-table
            class="p-0 m-0"
            :striped="false"
            :small="false"
            :hover="false"
            :items="csvImportErrors"
            :fields="csvErrorFields"
            responsive
          >
            <template v-slot:cell(barcode)="{ item }">
              <QuickOrderItemSelect
                v-model="item.selectedItem"
                :options="csvAutoCompleteItemsList"
                :get-option-label="getCsvItemLabel"
                :highlighted="isPanacheSelectionItemsError(item)"
                class="csv-error-item-select"
                @open="searchCsvErrorItem('', item)"
                @search="search => searchCsvErrorItem(search, item)"
                @input="selectCsvErrorItem(item)"
              >
                <template #search="search">
                  <input
                    class="vs__search"
                    v-bind="search.attributes"
                    :value="item.barcode || item.pctCode"
                    v-on="search.events"
                  >
                </template>
              </QuickOrderItemSelect>
            </template>
            <template v-slot:cell(quantity)="{ item }">
              <b-form-input v-model="item.quantity" type="number" min="1" class="text-right ml-auto" style="width:90px;"></b-form-input>
            </template>
            <template v-slot:cell(pctCode)="{ item }">
              <span :class="isPanacheSelectionItemsError(item) ? 'text-primary' : 'text-dark' " class="font-weight-bold" >{{ item.pctCode }}</span>
            </template>
            <template v-slot:cell(error)="{ item }">
              <span :class="isPanacheSelectionItemsError(item) ? 'text-primary' : 'text-danger' " >{{ item.error }}</span>
            </template>
            <template v-slot:cell(actions)="{ item }">
              <div class="d-flex align-items-center no-wrap">

                <!-- Loading -->
                <b-spinner
                  v-if="item.isRetrying || item.isResolvingItem"
                  small
                  class="mr-3"
                ></b-spinner>

                <i
                  v-else-if="isPanacheSelectionItemsError(item)"
                  class="fas fa-shopping-cart text-info mr-3 action-icon"
                  title="Sélectionner les articles"
                  @click="addLineToOrder(item)"
                ></i>

                <i
                  v-else
                  class="fas fa-plus text-success mr-3 action-icon"
                  title="Ajouter la ligne"
                  @click="addLineToOrder(item)"
                ></i>

                <i
                  class="fas fa-times text-danger action-icon"
                  :class="{ 'disabled-icon': item.isRetrying || item.isResolvingItem }"
                  title="Supprimer la ligne erronée"
                  @click="!item.isRetrying && !item.isResolvingItem && removeCsvErrorLine(item)"
                ></i>

              </div>
            </template>
          </b-table>
        </div>

      </div>
    </div>

    <b-modal v-model="showItemModal" hide-footer hide-header  size="xl" centered  @shown="selectFirstItem" @hidden="autoFocusQuantityInput">

      <div>

        <div class="col-lg-4 col-md-6 col-12">
          <b-input-group>
            <b-form-input  v-model="orderline.title" placeholder="Par référence ou désignation ou code à barre"  @keyup.native.enter="findItems();"
            class="text-dark font-weight-bold font-size-14  "
            ></b-form-input>
            <template v-slot:append>
                <b-button  size="sm" variant="primary" @click="findItems();">
                    <span class="font-weight-bold"> <i class="bx bx-search-alt font-weight-bold font-size-16 pr-1 pl-1 text-white align-middle"/>  </span> 
                </b-button>
            </template>                            
          </b-input-group>
        </div>

        <div class="table-responsive pt-2">   
            
            <b-table
                ref="table"
                :busy="isTableLoading"
                :items="itemsList"
                :fields="itemsListFields"
                :perPage="pagemodel.perPage"
                selectable
                select-mode="single"
                selected-variant="primary"
                :small="true"
                @row-selected="selectItem"
            >
            
            <template v-slot:head(ref)>
              {{ $t("catalog.header.reference") }} 
            </template>
            <template v-slot:head(title)>
              {{ $t("catalog.header.title") }} 
            </template>
            <template v-slot:head(position)>
              {{ $t("catalog.header.shockAbsorberPosition") }} 
            </template>
            <template v-slot:head(brand)>
              Laboratoire
            </template>
            <template v-slot:head(price)>
              {{ $t("catalog.header.price") }} 
            </template>
            <template v-slot:head(discountStr)>
              {{ $t("catalog.header.discount") }} 
            </template>
            <template v-slot:head(discountedPrice)>
              {{ $t("catalog.header.discountedPrice") }} 
            </template>
            <template v-slot:head(stockStatus)>
              {{ $t("catalog.header.stockStatus") }} 
            </template>
            <template v-slot:table-busy>
              <div class="text-center my-2">
                  <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
              </div>
            </template>
            <template v-slot:cell(discountStr)="{value}">
              {{value == 0 || value ==null ? '_' : value+'%'}} 
            </template>
            <template v-slot:cell(price)="{item,value}">
              <div :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>
            </template>
            <template v-slot:cell(priceTaxIncl)="{item, value}">
              <div :style="item.vat || item.pricePublic ? 'margin:2px' : ''" :class="item.stockStatus == 2 ? 'text-secondary' : item.stockStatus == 3 ? '' : 'text-dark'">{{value ? value : '_'}} </div>
              <div v-if="item.vat" class="text-muted font-weight-normal">{{item.vat ? 'TVA: ' + item.vat + '%' : '' }}</div>
            </template>
            <template v-slot:cell(brand)="{value}">
              {{value.name}} 
            </template>

            <template v-slot:cell(ref)="{item}">
              <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'">{{item.ref }}  </span>
            </template>

            <template v-slot:cell(image)="{item}">
              <i v-if="item.image" 
                class="fas fa-image ml-2 font-size-24 text-primary font-weight-bold float-right item-align-center" 
                title="image" 
                style="border-radius:5px; cursor: pointer;" 
                @click.stop="openImageModal(item)">
              </i>   
            </template>

            <template v-slot:cell(title)="{item}">
                  <span class="font-size-12 font-weight-bold" :class="item.gratuities && item.gratuities.length ? 'text-primary' : 'text-dark'" style="cursor: pointer;">{{item.title }}  </span>
                  <div> {{ item.barcode }}</div>
                  <div class="text-secondary" style="font-size: 10px;"> {{ item.expirationDate }}</div>

            </template>

            <template v-slot:cell(packageCount)="{value}">
              {{value ? value + ' / carton' : '-'}} 
            </template>

            <template v-slot:cell(gratuity)="{item}">
              <span  v-for="(itemGrat, index) in item.gratuities" :key="index" href="javascript: void(0);" class="m-1 badge badge-primary text-white font-weight-bold font-size-14 p-1">
                <i class="fas fa-star  mr-1"/>{{itemGrat.gratuity}} +{{itemGrat.gratuityGranted}}
              </span>
            </template>

            <template  v-slot:cell(stockStatus)="{item, value}">
                    <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                    <div v-else-if="value==3"  class="font-size-18"> _</div>
                    <i v-else-if="value==0" :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
                    <i v-else-if="value==1" :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
                    <div v-else-if="value==4" title="Vente controllée" class="text-info font-weight-bold font-size-14">
                      <span :class="item.alreadyOrderedPerDay ? 'strikethrough text-dark mr-1' : ''">{{ item.maxPerDay }} </span>
                      <span v-if="item.alreadyOrderedPerDay">{{   getRemainingQuantityInControlledSaled(item.maxPerDay, item.alreadyOrderedPerDay) }}</span> {{ '/' + ((item.salesControlDayCount && item.salesControlDayCount > 1) ? item.salesControlDayCount : '') + 'J' }}
                    </div> 
                    <div v-else-if="value == 5" class="d-flex align-items-center justify-content-center">
                      <span style="border-radius: 5px;" title="Article en répartition"
                      class="text-primary p-1 font-weight-bold font-size-16 d-flex align-items-center justify-content-center text-center"
                      >{{ item.repartitionQuantity }}</span>
                    </div>
            </template>
            </b-table>
            <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center mr-4 ml-4 mt-4 mb-4 text-danger" >{{ $t("catalog.empty") }} </span>
          </div>

            <!-- Pagination -->
            <div v-if="!isTableLoading" class="row pt-3 pl-2 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findItems()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[5,10,15,30]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findItems()" :disabled="isTableLoading" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->

      </div>

    </b-modal>

    <b-modal v-if="selectedItem"
        v-model="showImageModal" 
        hide-footer 
        centered 
        title-class="text-dark"
        size="lg"
        header-close-variant="danger">

        <template #modal-title>
            <div class="text-primary font-weight-bold">{{ selectedItem.title }}</div>

            <div class="text-dark font-size-14 mt-1">
              <span>{{ selectedItem.ref }}</span>
              <span v-if="selectedItem.brand && selectedItem.brand.name" > - {{ selectedItem.brand.name }}</span>
            </div>
        </template>
       
       <div class="row p-2 zoom-container">
        <img v-bind:src="'/api/image/get/'+selectedItem.image"    alt height="100%" width="100%" /> 
       </div>
    </b-modal>

    <b-modal
      v-if="this.orderData &&  this.orderData.id "
      v-model="showOrdersDetailsModal"
      title="Valider la commande"
      centered 
      title-class="text-primary d-print-none"
      title-tag="h5"
      header-close-variant="danger"
      header-class="d-print-none"
      class="modal-fullscreen"
      modal-class="order-validate-modal"
      size="xl"
      full-screen
      
      hide-footer
      hide-header
      >

      <!-- hide-header modal: explicit close (X), top right; only hides the modal, the order is kept -->
      <button type="button" class="order-modal-close d-print-none" title="Fermer" aria-label="Fermer" @click="showOrdersDetailsModal = false"><i class="bx bx-x" aria-hidden="true"></i></button>
      <OrderModal :orderId="this.orderData.id" :linesCount="this.orderData.lines.length" v-on:update="closeOrderModal" />
    </b-modal>

</div>
</template>

<style scoped>


    ::v-deep .vs--searchable .vs__dropdown-toggle {
      border-radius:5px 0px 0px 05px !important;
      border-right:0px;
    }
 
    ::v-deep .v-select-auto-complete  .vs__actions {
      display: none;
    }

    ::v-deep .v-select-auto-complete  .vs__actions {
      display: none;
    }

</style>


<style>

.csv-error-item-select {
  width: 100%;
  min-width: 0;
}

.csv-error-item-select .vs__dropdown-toggle {
  width: 100%;
}
.v-select-auto-complete .vs__dropdown-toggle {
  background: #dddddd59 !important;
  border: none !important;
  color: #fff !important;
  text-transform: lowercase !important;
  font-variant: small-caps !important;
}

.v-select-auto-complete .vs__placeholder {
  color: #ccc !important;
  text-transform: lowercase !important;
  font-variant: small-caps !important;
  font-size: 12px;
}

.dropdown-order-line .vs__dropdown-option{
    background-color: #df101059 !important;

}


.action-icon {
  cursor: pointer;
  font-size: 16px;
  transition: opacity 0.15s ease;
}

.action-icon:hover {
  opacity: 0.65;
}

.disabled-icon {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

</style>

<style scoped>
/* quick order grid: column headers and the entry line (look only) */
.qo-grid-wrap { margin-top: .75rem; background: #fff; }
.qo-grid { margin-bottom: 0; }
.qo-grid ::v-deep table { border-collapse: separate; border-spacing: 0; }
/* grey rounded border around the header band only; the entry line has none */
.qo-grid ::v-deep thead th:first-child { border-left: 1px solid #e4e7ec; border-radius: 10px 0 0 10px; }
.qo-grid ::v-deep thead th:last-child { border-right: 1px solid #e4e7ec; border-radius: 0 10px 10px 0; }
.qo-grid ::v-deep thead th { padding: .7rem 1rem; border-top: 1px solid #e4e7ec; border-bottom: 1px solid #e4e7ec; background: #f8f9fb; color: #475467; font-size: 11.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; white-space: nowrap; vertical-align: middle; }
.qo-grid ::v-deep tbody td { padding: .85rem 1rem; border: 0; background: #fff; vertical-align: middle; }
.qo-grid ::v-deep tbody td:nth-child(1),
.qo-grid ::v-deep tbody td:nth-child(4),
.qo-grid ::v-deep tbody td:nth-child(5) { color: #98a2b3; }
/* the article field joins the catalogue button on its right */
.qo-grid__search ::v-deep .qo-item-select.vs--searchable .vs__dropdown-toggle { border-right: 0; border-radius: 8px 0 0 8px !important; }
.qo-grid__catalog-btn { display: inline-flex; align-items: center; justify-content: center; min-width: 44px; height: 42px; border: 1px solid #d0d5dd !important; border-radius: 0 8px 8px 0 !important; background: #f2f4f7 !important; color: #344054 !important; }
.qo-grid__catalog-btn:hover { background: #e4e7ec !important; color: #101828 !important; }
.qo-grid__qty { height: 42px; border: 1px solid #d0d5dd; border-radius: 8px; font-size: 15px; font-weight: 600; }
.qo-grid__qty:focus { border-color: #34469c; box-shadow: 0 0 0 3px rgba(52, 70, 156, .12); }
</style>

<style scoped>
/* "Valider la commande" modal (hide-header): close button, top right, stays reachable on phones */
.order-modal-close { position: absolute; top: .5rem; right: .5rem; z-index: 5; display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; padding: 0; border: 0; background: transparent; color: #344054; font-size: 28px; line-height: 1; cursor: pointer; }
.order-modal-close:hover { color: #101828; }
.order-modal-close:focus-visible { outline: 2px solid var(--primary, #34469c); outline-offset: 2px; }
</style>
